import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from '@xyflow/react'
import { PfdEdgeProps } from 'features/processFlowDiagrams/types'

import { SwapEdgeButton } from './SwapEdgeButton'

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {
    strokeWidth: 1,
    stroke: 'gray',
  },
  markerEnd,
  markerStart,
  data,
}: PfdEdgeProps) {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    stepPosition: 1,
    targetPosition,
    borderRadius: 0,
  })

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        markerStart={markerStart}
        style={style}
      />
      {!data?.confirmedEdge && (
        <EdgeLabelRenderer>
          <SwapEdgeButton labelX={labelX} labelY={labelY} id={id} />
        </EdgeLabelRenderer>
      )}
    </>
  )
}
